import React, { useContext, useState } from 'react';
import { useSoftDeleteFormsMenuFormTemplateMutation } from 'shared/types/graphql';
import { FormsContext } from 'pages/Forms/context/FormsContext';
import useForms from 'pages/Forms/hooks/useForms';
import { useHistory } from 'react-router-dom';
import { useCustomToast } from 'shared/hooks/useCustomToast';
import {
  CModal,
  ModalOverlay,
  ModalContent,
  CModalHeader,
  CModalFooter,
  CModalBody,
  ModalCloseButton,
  Text,
  Button,
} from '@televet/kibble-ui';

interface IDeleteFormModal {
  isOpen: boolean;
  onClose: () => void;
  formTemplateId: string;
  formTemplateName: string;
}

const DeleteFormModal = ({
  isOpen,
  onClose,
  formTemplateId,
  formTemplateName,
}: IDeleteFormModal): JSX.Element | null => {
  const [deleteFormTemplate] = useSoftDeleteFormsMenuFormTemplateMutation();
  const { dispatch } = useContext(FormsContext);
  const { getFormTemplates } = useForms();
  const history = useHistory();
  const { toastMessagePop } = useCustomToast();
  const [deleting, setDeleting] = useState(false);

  const onDeleteForm = async (): Promise<void> => {
    setDeleting(true);
    await deleteFormTemplate({ variables: { where: { id: formTemplateId } } });
    await getFormTemplates();
    dispatch({ type: 'RESET_CONTEXT', payload: {} });
    toastMessagePop('Form Deleted');
    history.push('/forms');
    setDeleting(false);
    onClose();
  };

  return (
    <CModal size="md" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <CModalHeader fontSize="3xl" pb={1}>
          Delete Form
        </CModalHeader>
        <ModalCloseButton />
        <CModalBody>
          <Text>Are you sure you want to delete {formTemplateName}? This action cannot be undone.</Text>
        </CModalBody>
        <CModalFooter justifyContent="space-between">
          <Button variant="tertiary" mr={3} onClick={onClose} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="primaryDestructive" onClick={onDeleteForm} isLoading={deleting}>
            Delete
          </Button>
        </CModalFooter>
      </ModalContent>
    </CModal>
  );
};

export default DeleteFormModal;
